import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { CreateCustomSafe } from '../../types/scenario-modeling.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const usePatchCustomSafe = () => {
  const { invalidateQuery: invalidateCalculationQueries } = useInvalidateQueries(
    QueryKey.GET_CONVERSION_SUMMARY,
    QueryKey.CALC_CUSTOM_SAFE,
    QueryKey.CALC_SCENARIO_SAFES,
    QueryKey.CALC_SCENARIO_INVESTMENT,
  );

  const { mutate: updateCustomSafe, isPending } = useAppMutation(
    [QueryKey.PATCH_SCENARIO_CUSTOM_SAFE],
    {
      mutationFn: ({
        data,
        scenarioId,
        safeId,
      }: {
        data: CreateCustomSafe;
        safeId: string;
        scenarioId: string;
      }) =>
        ApiService.patch(
          {
            endpoint: BackendRoute.SCENARIOS,
            routePath: [scenarioId, 'custom-safes', safeId],
          },
          {
            body: data,
          },
        ),
      onSuccess: () => {
        invalidateCalculationQueries();
      },
    },
  );
  return { updateCustomSafe, isPending };
};
